import { Icon } from '@/components/Icon';
import { haptic } from '@/lib/telegram';
import { Italic } from './parts';

interface SetupCoverProps {
  onStart: () => void;
  onOtherDevice: () => void;
}

const STEPS = [
  { n: '01', t: 'приложение', s: 'happ — бесплатно из app store' },
  { n: '02', t: 'подписка', s: 'добавим конфиг одним тапом' },
  { n: '03', t: 'готово', s: 'включишь vpn — всё работает' },
];

export function SetupCover({ onStart, onOtherDevice }: SetupCoverProps) {
  return (
    <div
      style={{
        padding: '12px 18px 130px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ marginTop: 8, marginBottom: 18 }}>
        <div className="eyebrow" style={{ marginBottom: 10 }}>
          установка · ios
        </div>
        <h1
          style={{
            fontFamily: "'Instrument Serif', serif",
            fontWeight: 400,
            fontSize: 44,
            lineHeight: 0.96,
            margin: 0,
            color: 'var(--ink)',
            letterSpacing: '-0.02em',
          }}
        >
          три шага.
          <br />
          <Italic>пара минут.</Italic>
        </h1>
        <p
          style={{
            fontSize: 13.5,
            color: 'var(--ink-2)',
            marginTop: 14,
            lineHeight: 1.5,
            maxWidth: 320,
          }}
        >
          сначала установим приложение happ. потом добавим подписку. в конце — проверим, что всё
          работает
        </p>
      </div>

      <div
        style={{
          background: '#fbf8f1',
          border: '1px solid var(--paper-3)',
          borderRadius: 18,
          padding: '18px 20px',
          margin: '8px 0 16px',
        }}
      >
        {STEPS.map((s, i) => {
          const isLast = i === STEPS.length - 1;
          return (
            <div
              key={s.n}
              style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: 16,
                paddingBottom: isLast ? 0 : 14,
                marginBottom: isLast ? 0 : 14,
                borderBottom: isLast ? 'none' : '1px solid var(--paper-3)',
              }}
            >
              <div
                style={{
                  fontFamily: "'Instrument Serif', serif",
                  fontStyle: 'italic',
                  fontSize: 26,
                  color: 'var(--ink-3)',
                  letterSpacing: '-0.02em',
                  minWidth: 36,
                }}
              >
                {s.n}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, color: 'var(--ink)' }}>{s.t}</div>
                <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>{s.s}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ flex: 1 }} />

      <button
        onClick={() => {
          haptic('medium');
          onStart();
        }}
        className="btn btn-moss"
        style={{ width: '100%', height: 54, fontSize: 14.5, marginBottom: 10 }}
      >
        начать настройку на этом устройстве
        <Icon name="arrow" size={14} stroke="#fff" sw={2} />
      </button>
      <button
        onClick={() => {
          haptic('light');
          onOtherDevice();
        }}
        className="btn btn-ghost"
        style={{ width: '100%', height: 50, fontSize: 13.5 }}
      >
        установить на другом устройстве
      </button>
    </div>
  );
}
